import React from "react";
import cn from "classnames";

import { PopoverTriggerProps } from "../types";

import classes from "../Popover.module.scss";

const PopoverTrigger: React.FC<PopoverTriggerProps> = ({
  children,
  className,
  isOpen,
  triggerRef,
  tagName = "div",
}) =>
  React.createElement(
    tagName,
    {
      className: cn(classes.trigger, className),
      ref: triggerRef,
    },
    children instanceof Function ? children({ isOpen }) : children
  );

export default PopoverTrigger;
